import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
jQuery(document).ready(function ($) {
  if (jQuery('body.tax-product_cat').length) {
    jQuery('li.current-cat').parents('li.current-cat-parent').each(function () {
      $(this).find('> ul.sub-sub-menu').css('display', 'block');
      $(this).find('> .xts-submenu-opener').addClass('opened').addClass('opened xts-opened');
    });
  }
});